import { render, staticRenderFns } from "./ZastosowaniaForm.vue?vue&type=template&id=3533a949&"
import script from "./ZastosowaniaForm.vue?vue&type=script&lang=ts&"
export * from "./ZastosowaniaForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports